import { getAPI } from "@/api/axios-base";

function postOrPatch(url, body) {
  if (body.uuid) {
    return getAPI.patch(`${url}${body.uuid}/`, body);
  } else return getAPI.post(url, body);
}

export async function createOrUpdate(url, body, fileField) {
  if (!fileField) {
    return postOrPatch(url, body);
  } else if (typeof body[fileField] !== "string" && body[fileField]) {
    const formdata = new FormData();
    formdata.append(fileField, body[fileField]);
    const newBody = { ...body };
    delete newBody[fileField];
    const response = (await postOrPatch)(url, newBody);
    return getAPI.patch(`${url}${response.data.uuid}/`, formdata, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  } else {
    const newBody = { ...body };
    delete newBody[fileField];
    return postOrPatch(url, newBody);
  }
}

export function createOrUpdateJSON(url, body) {
  if (body.uuid) {
    return getAPI.patch(url + body.uuid + "/", body);
  } else return getAPI.post(url, body);
}

export function getFormattedDate(date) {
  if (!date) return "";

  if (date instanceof Date) {
    return date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
  }

  return date;
}
